import AddParentLayout from '../components/organisms/AddParentLayout';
import axios from 'axios';
import config from '../config';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const AddParent = () => {
  const navigate = useNavigate();
  const [student, setStudent] = useState([]);
  const { student_id } = useParams();
  const [parentDetail, setParentDetail] = useState({
    mode: 'addParent',
    auth: localStorage.getItem('token'),
    student_id,
    parent_name: '',
    parent_relationship: '',
    parent_identity_number: '',
    parent_mobile: '',
    parent_email: '',
    parent_religion: 'catholic',
  });

  useEffect(() => {
    const data = new FormData();
    data.append('auth', localStorage.getItem('token'));
    data.append('studentId', student_id);
    data.append('mode', 'getStudentByIdLite');

    axios.post(config.STUDENTS_API, data).then(output => {
      if (output.data.response.status === 'OK') {
        setStudent(output.data.response.student);
      } else {
        // catch error
      }
    });
  }, []);

  const handleChange = e => {
    setParentDetail(prev => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  const handleFormSubmission = () => {
    axios.post(config.PARENTS_API, parentDetail).then(output => {
      // console.log(output.data.response);
      navigate(`/manage/students/${student_id}`);
    });
  };

  // useEffect(() => {
  //   console.log(parentDetail);
  // }, [parentDetail]);

  return (
    <AddParentLayout
      student={student}
      handleChange={handleChange}
      handleFormSubmission={handleFormSubmission}
    />
  );
};

export default AddParent;
